var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideocam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1777_2016",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1777_2016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.00012 15C2.58762 15 2.2345 14.8531 1.94075 14.5594C1.647 14.2656 1.50012 13.9125 1.50012 13.5V4.5C1.50012 4.0875 1.647 3.73438 1.94075 3.44063C2.2345 3.14688 2.58762 3 3.00012 3H12.0001C12.4126 3 12.7657 3.14688 13.0595 3.44063C13.3532 3.73438 13.5001 4.0875 13.5001 4.5V7.875L15.8626 5.5125C15.9876 5.3875 16.1251 5.35625 16.2751 5.41875C16.4251 5.48125 16.5001 5.6 16.5001 5.775V12.225C16.5001 12.4 16.4251 12.5188 16.2751 12.5813C16.1251 12.6438 15.9876 12.6125 15.8626 12.4875L13.5001 10.125V13.5C13.5001 13.9125 13.3532 14.2656 13.0595 14.5594C12.7657 14.8531 12.4126 15 12.0001 15H3.00012ZM3.00012 13.5H12.0001V4.5H3.00012V13.5Z",
    fill: "#357EFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideocam);
export default __webpack_public_path__ + "static/media/videocam.1f71ac8cb58377447821972cb425784d.svg";
export { ForwardRef as ReactComponent };